import { Component } from '@angular/core';

@Component({
  selector: 'app-cards4-examples-25',
  templateUrl: './cards4-examples-25.component.html'
})
export class Cards4Examples25Component {}
